import axios from 'axios';
import type { AxiosRequestConfig } from 'axios';
// config
import { BACKEND_URL } from '../shared-config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  headers: {
    common: {
      'Access-Control-Expose-Headers': 'content-disposition',
    },
  },
  baseURL: BACKEND_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const correlationId = Math.random().toString(36).substring(7);
  config.headers['X-Correlation-ID'] = correlationId;

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    const { appInsights } = window as any;
    if (appInsights && error.response) {
      appInsights.trackException({
        exception: new Error(`API Error: ${error.response.status} ${error.response.statusText}`),
        properties: {
          url: error.config?.url,
          method: error.config?.method,
          status: error.response.status,
          correlationId: error.config?.headers?.['X-Correlation-ID'],
        },
      });
    }

    return Promise.reject((error.response && error.response.data) || 'Something went wrong');
  }
);

export default axiosInstance;
export type { AxiosRequestConfig };
